

import Component, {mixins} from "vue-class-component";
import AuthMixin from "@/mixins/auth.mixin";
import {TrainingMaterialCompletionRequest, TrainingMaterialCompletionRow} from "shared/api/routes/report";
import {apiHandler} from "@/services/api-handler";
import {Api} from "shared/api";
import {IMaterial} from "shared/entities/material";
import {IUser} from "shared/entities/user";
import {Watch} from "vue-property-decorator";

@Component({})
export default class TrainingCompletion extends mixins(AuthMixin) {
    rows: TrainingMaterialCompletionRow[] = [];
    materials: Record<string, IMaterial> = {};
    users: IUser[] = [];
    locations: string[] = [];
    filters = {
        user: undefined as string | undefined,
        location: undefined as string | undefined,
        startDate: undefined as string | undefined,
        endDate: undefined as string | undefined,
    };

    completed(row: TrainingMaterialCompletionRow) {
        return row.completed.map(mId => {
            if (this.materials[mId].hasQuiz && row.quizScores.hasOwnProperty(mId)) {
                return `${this.materials[mId].title} (${row.quizScores[mId][0]}/${row.quizScores[mId][1]})`;
            } else {
                return this.materials[mId].title;
            }
        }).join(", ");
    }

    async mounted() {
        this.users = await apiHandler(() => Api.user.Get());
        this.locations = this.users.map(u => u.location).filter((v, i, a) => a.indexOf(v) === i);
        const materials = await apiHandler(() => Api.material.Get());
        for (const material of materials) this.materials[material.id] = material;
        await this.loadResults();
    }

    @Watch("filters", {deep: true})
    async loadResults() {
        const req: TrainingMaterialCompletionRequest = {};
        if (this.filters.user) req.user = this.filters.user;
        if (this.filters.location) req.location = this.filters.location;
        if (this.filters.startDate) req.from = this.filters.startDate.toString();
        if (this.filters.endDate) req.to = this.filters.endDate.toString();
        this.rows = await apiHandler(() => Api.report.materialCompletion.Get(req));
    }
}

